module.exports = __webpack_public_path__ + "91c163b58ef9761471339342cfe68058.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img1_3.jpg
// module id = 550
// module chunks = 0